import React from "react";
import { faFileImage, faFilePdf, faFileWord } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import FetchButton from "../../../../common/button/FetchButton";
export const icon = (type) => {
  return type === "pdf" ? faFilePdf : type === "word" ? faFileWord : faFileImage;
};

export const iconColor = (type) => {
  return type === "pdf" ? "danger" : type === "word" ? "info" : "dark";
};

function SubmittedDocumentation({ letters, attachments, finances }) {
  const { t } = useTranslation();

  return (
    <>
      <div className="subtitle mt-4">
        {t("requests.overview.preview.submittedDocumentation.letters")} ({letters.length})
      </div>
      <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {letters.map((letter, index) => (
            <tr key={"letter" + index}>
              <td>{letter.label}</td>
              <td className="has-text-right">
                <FetchButton
                  href={letter.href}
                  className="button is-white has-background-transparent has-background-transparent-on-hover"
                  text={
                    <FontAwesomeIcon
                      className={`is-clickable has-text-${iconColor(letter.content)}`}
                      icon={icon(letter.content)}
                      size={"2x"}
                    />
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="subtitle">
        {t("requests.overview.preview.submittedDocumentation.attachments")} ({attachments.length})
      </div>
      <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {attachments.map((attachment, index) => (
            <tr key={"attachment" + index}>
              <td>{attachment.label}</td>
              <td className="has-text-right">
                <FetchButton
                  href={attachment.href}
                  className="button has-background-transparent is-white has-background-transparent-on-hover"
                  text={
                    <FontAwesomeIcon
                      className={`is-clickable has-text-${iconColor(attachment.content)}`}
                      icon={icon(attachment.content)}
                      size={"2x"}
                    />
                  }
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {/* <div className="subtitle">
        {t("requests.overview.preview.submittedDocumentation.finances")} ({finances.length})
      </div>
      <table className="is-fullwidth table is-size-6 is-hoverable">
        <tbody>
          {finances.map((finance, index) => (
            <tr key={"finance" + index}>
              <td>{finance.label}</td>
              <td className="has-text-right">
                <a href={finance.href} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon
                    className={`is-clickable has-text-${iconColor(finance.content)}`}
                    icon={icon(finance.content)}
                    size={"2x"}
                  />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table> */}
    </>
  );
}

export default SubmittedDocumentation;
